import SearchInterface from 'components/knowledge-base/search/InstantSearch'
import { Dispatch, ReactElement, SetStateAction } from 'react'
import { Flex } from 'theme-ui'

export default function GarrySearchBar({
  hasInputValue,
  setHasInputValue,
}: {
  hasInputValue: boolean
  setHasInputValue: Dispatch<SetStateAction<boolean>>
}): ReactElement {
  return (
    <Flex
      data-testid="search-bar"
      sx={{
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        mt: '2.4rem',
      }}
    >
      <SearchInterface
        data-testid="search-interface"
        hasInputValue={hasInputValue}
        setHasInputValue={setHasInputValue}
      />
    </Flex>
  )
}
